const medicalFillInFormItemTypes = {
  new: "new",
  view: "view",
  edit: "edit",
  list: "list",
  print: "print",
  initialExamView: "initialExamView",
};

export default medicalFillInFormItemTypes;
